import { defineComponent as _defineComponent } from 'vue';
import { MoreHorizontal } from 'lucide-vue-next';
import { reactiveOmit } from '@vueuse/core';
import { PaginationEllipsis } from 'reka-ui';
import { cn } from './../utils';
export default /*@__PURE__*/ _defineComponent({
    __name: 'PaginationEllipsis',
    props: {
        asChild: { type: Boolean, required: false },
        as: { type: null, required: false },
        class: { type: [Boolean, null, String, Object, Array], required: false, skipCheck: true }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const delegatedProps = reactiveOmit(props, 'class');
        const __returned__ = { props, delegatedProps, get MoreHorizontal() { return MoreHorizontal; }, get PaginationEllipsis() { return PaginationEllipsis; }, get cn() { return cn; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
